export const defaultCollaborationQueryParams: Paths.CreatorsCollaborations.Get.QueryParameters = {
    pageIndex: 0,
    limit: 40
};
